import { getLocalizedRoutes } from '@seek/melways-sites';

import type { EmployerSiteName } from 'src/types/app';
import type { AppRoute } from 'src/types/routes';

import * as id from '../constants/pageUid';
import * as path from '../constants/routes';

export const routes: AppRoute[] = [
  {
    name: id.PAGE_ID_CREATE,
    route: path.ROUTE_CREATE,
  },
  { name: id.PAGE_ID_CLASSIFY, route: path.ROUTE_CLASSIFY },
  { name: id.PAGE_ID_CONCIERGE, route: path.ROUTE_CONCIERGE },
  {
    name: id.PAGE_ID_GUARANTEED_HIRE,
    route: path.ROUTE_GUARANTEED_HIRE,
  },
  {
    name: id.PAGE_ID_PREMIUM_PLUS,
    route: path.ROUTE_PREMIUM_PLUS,
  },
  { name: id.PAGE_ID_MANAGE, route: path.ROUTE_MANAGE },
  {
    name: id.PAGE_ID_PAY_AND_POST,
    route: path.ROUTE_PAY_AND_POST,
  },
  {
    name: id.PAGE_ID_SELECT_AD_TYPE,
    route: path.ROUTE_SELECT_AD_TYPE,
  },
  { name: id.PAGE_ID_SUCCESS, route: path.ROUTE_SUCCESS },
  { name: id.PAGE_ID_WRITE, route: path.ROUTE_WRITE },
  { name: id.PAGE_ID_EDIT, route: path.ROUTE_EDIT },
  {
    name: id.PAGE_ID_EDIT_PAY_AND_POST,
    route: path.ROUTE_EDIT_PAY_AND_POST,
  },
  {
    name: id.PAGE_ID_EDIT_SUCCESS,
    route: path.ROUTE_EDIT_SUCCESS,
  },
  {
    name: id.PAGE_ID_REFRESH,
    route: path.ROUTE_REFRESH,
  },
  {
    name: id.PAGE_ID_REFRESH_SUCCESS,
    route: path.ROUTE_REFRESH_SUCCESS,
  },
  {
    name: id.PAGE_ID_REFRESH_ERROR,
    route: path.ROUTE_REFRESH_ERROR,
  },
  {
    name: id.PAGE_ID_TEST_PAGE,
    route: path.ROUTE_TEST_PAGE,
    onlyAvailableInEnv: ['dev'],
  },
  {
    name: id.PAGE_ID_MULTI_LOCATION,
    route: path.ROUTE_MULTI_LOCATION,
  },
];

export type RouteName = (typeof routes)[number]['name'];

export const getLocalisedRoutes = (site: EmployerSiteName) => {
  const localiseRoutes = getLocalizedRoutes(routes);
  return localiseRoutes(site);
};
